//@flow

type BonusErrorsAndSpecificTranslations = { [bonusError: string]: string };

export const bonusErrorsAndSpecificTranslations: BonusErrorsAndSpecificTranslations = {
  DELIVERY_PARTNER_CLOSED: 'error.expressDeliveryClosed',
  GODFATHER_GODCHILD_NRIC: 'SignUp.ConfirmPlan.referralPromotion.invalid.notYourself',
  GODFATHER_EXPIRED: 'SignUp.ConfirmPlan.referralPromotion.invalid.expired',
  GODFATHER_NO_LINE: 'SignUp.ConfirmPlan.referralPromotion.invalid.noLine',
  GODFATHER_NOT_FOUND: 'SignUp.ConfirmPlan.referralPromotion.invalid.notFound',
  MSISDN_NOT_AVAILABLE: 'SignUp.ChooseNumber.numberNotAvailable',
  NOT_FIRST_SUBSCRIPTION: 'SignUp.ConfirmPlan.referralPromotion.invalid.notFirstSubscription',
  PROMO_NOT_AVAILABLE: 'error.validation.promotionCodeExpired',
  SUBSCRIBER_AS_REFERRER: 'SignUp.ConfirmPlan.referralPromotion.invalid.notYourself',
};
